import { ExplanationOfGradesRequestStatus } from '../table/types';
import { GradingPartyDocument } from '../../services/gradingPartyService';
import { AttachmentAction } from '../attachment/actions';

export enum TypeKeys {
    LOAD_INITIAL_DATA = 'explanationOfGrades/LOAD_INITIAL_DATA',
    LOAD_EXPLANATION = 'explanationOfGrades/LOAD_EXPLANATION',
    SAVE_EXPLANATION = 'explanationOfGrades/SAVE_EXPLANATION',
    UPDATE_CONTENT = 'explanationOfGrades/UPDATE_CONTENT',
    SET_EXPLANATION_REQUESTED_STATUS = 'explanationOfGrades/SET_EXPLANATION_REQUESTED_STATUS',
    SET_EDITING = 'explanationOfGrades/SET_EDITING',
    MARK_AS_READY = 'explanationOfGrades/MARK_AS_READY',
    SET_DRAFT = 'explanationOfGrades/SET_DRAFT',
    LOAD_CANDIDATE_INFO = 'explanationOfGrades/LOAD_CANDIDATE_INFO',
    SEND_EXPLANATION = 'explanationOfGrades/SEND_EXPLANATION',
    CANCEL_REQUEST_OF_EXPLANATION = 'explanationOfGrades/CANCEL_REQUEST_OF_EXPLANATION',
    EDIT_DUE_DATE_OF_EXPLANATION = 'explanationOfGrades/EDIT_DUE_DATE_OF_EXPLANATION',
    ATTACH_FILE_FOR_EXPLANATION = 'explanationOfGrades/ATTACH_FILE_FOR_EXPLANATION',
    EXPLANATION_LOADED = 'explanationOfGrades/EXPLANATION_LOADED',
    EXPLANATION_ID_LOADED = 'explanationOfGrades/EXPLANATION_ID_LOADED',
    SET_NEW_DEADLINE = 'explanationOfGrades/SET_NEW_DEADLINE',
    RESET_DIALOG_ACTION = 'explanationOfGrades/RESET_DIALOG_ACTION',
    SAVE_NEW_DEADLINE = 'explanationOfGrades/SAVE_NEW_DEADLINE',
    SET_INITIAL_DEADLINE = 'explanationOfGrades/SET_INITIAL_DEADLINE',
    SET_EXPLANATION_AS_NOT_REQUESTED = 'explanationOfGrades/SET_EXPLANATION_AS_NOT_REQUESTED',
    RESET_STATE = 'explanationOfGrades/RESET_STATE',
    LOCK_EXPLANATION = 'explanationOfGrades/LOCK_EXPLANATION',
    FETCH_NOTES = 'explanationOfGrades/FETCH_NOTES',
    LOAD_NOTES = 'explanationOfGrades/LOAD_NOTES',
    RESET_NOTES = 'explanationOfGrades/RESET_NOTES',
    SET_EXPLANATION_LOCKED = 'explanationOfGrades/SET_EXPLANATION_LOCKED',
    SET_READ_ONLY = 'explanationOfGrades/SET_READ_ONLY',
    UNLOCK_EXPLANATION = 'explanationOdGrades/UNLOCK_EXPLANATION',
    GET_EXPLANATION_ID_FAILED = 'GET_EXPLANATION_ID_FAILED',
    GET_SUBMITTED_EXPLANATION_FAILED = 'GET_SUBMITTED_EXPLANATION_FAILED',
    FETCH_EXPLANATION_OF_GRADES_FAILED = 'FETCH_EXPLANATION_OF_GRADES_FAILED',
    SAVE_EXPLANATION_OF_GRADES_FAILED = 'SAVE_EXPLANATION_OF_GRADES_FAILED',
    UPDATE_EXPLANATION_OF_GRADES_STATUS_FAILED = 'UPDATE_EXPLANATION_OF_GRADES_STATUS_FAILED',
    UPDATE_EXPLANATION_DEADLINE_FAILED = 'UPDATE_EXPLANATION_DEADLINE_FAILED',
    LOCK_EXPLANATION_FAILED = 'LOCK_EXPLANATION_FAILED',
    CALL_INSERT_NOTES_FAILED = 'CALL_INSERT_NOTES_FAILED',

}

export interface UnlockExplanation {
    type: TypeKeys.UNLOCK_EXPLANATION;
    featureId: string;
}
export interface SetReadOnlyAction {
    type: TypeKeys.SET_READ_ONLY;
    featureId: string;
}

export interface LoadInitialData {
    type: TypeKeys.LOAD_INITIAL_DATA;
    featureId: string;
}


export interface ResetNotesAction {
    type: TypeKeys.RESET_NOTES;
    featureId: string;
}

export interface FetchNotesAction {
    type: TypeKeys.FETCH_NOTES;
    featureId: string;
}

export interface LoadNotesAction {
    type: TypeKeys.LOAD_NOTES;
    featureId: string;
    notes: string;
}

export interface ResetStateAction {
    type: TypeKeys.RESET_STATE;
    featureId: string;
}

export interface SetExplanationAsNotRequestedAction {
    type: TypeKeys.SET_EXPLANATION_AS_NOT_REQUESTED;
    featureId: string;
}

export interface SetInitialDeadlineAction {
    type: TypeKeys.SET_INITIAL_DEADLINE;
    date: string;
    featureId: string;
}

export interface SaveNewDeadlineAction {
    type: TypeKeys.SAVE_NEW_DEADLINE;
    featureId: string;
}

export interface ResetDialogAction {
    type: TypeKeys.RESET_DIALOG_ACTION;
    featureId: string;
}

export interface SetNewDeadlineAction {
    type: TypeKeys.SET_NEW_DEADLINE;
    featureId: string;
    deadline: string;
}

export interface ExplanationLoadedAction {
    type: TypeKeys.EXPLANATION_LOADED;
    featureId: string;
    explanationOfGrades: any;
}

export interface ExplanationIdLoadedAction {
    type: TypeKeys.EXPLANATION_ID_LOADED;
    featureId: string;
    explanationId: number;
}

export interface CancelRequestOfExplanationAction {
    type: TypeKeys.CANCEL_REQUEST_OF_EXPLANATION;
    featureId: string;
}

export interface EditDueDateOfExplanationAction {
    type: TypeKeys.EDIT_DUE_DATE_OF_EXPLANATION;
    featureId: string;
}

export interface AttachFileForExplanationAction {
    type: TypeKeys.ATTACH_FILE_FOR_EXPLANATION;
    featureId: string;
}

export interface SendExplanationAction {
    type: TypeKeys.SEND_EXPLANATION;
    featureId: string;
    sendToAllCandidates?: boolean;
}

export interface LoadCandidateInfoAction {
    type: TypeKeys.LOAD_CANDIDATE_INFO;
    gradingPartyDocument: GradingPartyDocument;
    featureId: string;
}

export interface MarkAsReadyAction {
    type: TypeKeys.MARK_AS_READY;
    featureId: string;
}

export interface SetDraftAction {
    type: TypeKeys.SET_DRAFT;
    featureId: string;
}

export interface SetEditingAction {
    type: TypeKeys.SET_EDITING;
    isEditing: boolean;
    featureId: string;
}

export interface SetExplanationRequestedStatusAction {
    type: TypeKeys.SET_EXPLANATION_REQUESTED_STATUS;
    status: ExplanationOfGradesRequestStatus;
    featureId: string;
}

export interface LoadExplanationAction {
    type: TypeKeys.LOAD_EXPLANATION;
    explanationId: number;
    featureId: string;
}

export interface SaveExplanationAction {
    type: TypeKeys.SAVE_EXPLANATION;
    featureId: string;
}

export interface UpdateContentAction {
    type: TypeKeys.UPDATE_CONTENT;
    featureId: string;
    newContent: string;
}

export interface LockExplanation {
    type: TypeKeys.LOCK_EXPLANATION;
    featureId: string;
}

export interface SetExplanationLocked {
    type: TypeKeys.SET_EXPLANATION_LOCKED;
    featureId: string;
    lockInfo: any;
}

export type ActionTypes =
    LoadInitialData
    | LoadExplanationAction
    | SaveExplanationAction
    | UpdateContentAction
    | SetEditingAction
    | MarkAsReadyAction
    | SetDraftAction
    | LoadCandidateInfoAction
    | SendExplanationAction
    | CancelRequestOfExplanationAction
    | EditDueDateOfExplanationAction
    | AttachFileForExplanationAction
    | ExplanationLoadedAction
    | ExplanationIdLoadedAction
    | SetNewDeadlineAction
    | ResetDialogAction
    | SaveNewDeadlineAction
    | SetInitialDeadlineAction
    | SetExplanationAsNotRequestedAction
    | ResetStateAction
    | LockExplanation
    | SetExplanationRequestedStatusAction
    | FetchNotesAction
    | LoadNotesAction
    | ResetNotesAction
    | SetExplanationLocked
    | SetReadOnlyAction
    | UnlockExplanation
    | AttachmentAction;

export const unlockExplanation = (featureId: string): UnlockExplanation => ({
    featureId,
    type: TypeKeys.UNLOCK_EXPLANATION,
});

export const loadInitialData = (featureId: string): LoadInitialData => ({
    featureId,
    type: TypeKeys.LOAD_INITIAL_DATA,
});
export const setReadOnly = (featureId: string): SetReadOnlyAction => ({
    featureId,
    type: TypeKeys.SET_READ_ONLY,
});

export const resetNotes = (featureId: string): ResetNotesAction => ({
    featureId,
    type: TypeKeys.RESET_NOTES,
});

export const fetchNotes = (featureId: string): FetchNotesAction => ({
    featureId,
    type: TypeKeys.FETCH_NOTES,
});

export const loadNotes = (featureId: string, notes: string): LoadNotesAction => ({
    featureId,
    notes,
    type: TypeKeys.LOAD_NOTES,
});

export const resetState = (featureId: string): ResetStateAction => ({
    featureId,
    type: TypeKeys.RESET_STATE,
});

export const setExplanationAsNotRequested = (featureId: string): SetExplanationAsNotRequestedAction => ({
    featureId,
    type: TypeKeys.SET_EXPLANATION_AS_NOT_REQUESTED,
});

export const setInitialDeadline = (featureId: string, date: string): SetInitialDeadlineAction => ({
    featureId,
    date,
    type: TypeKeys.SET_INITIAL_DEADLINE,
});

export const saveNewDeadline = (featureId: string): SaveNewDeadlineAction => ({
    featureId,
    type: TypeKeys.SAVE_NEW_DEADLINE,
});

export const resetDialogAction = (featureId: string): ResetDialogAction => ({
    featureId,
    type: TypeKeys.RESET_DIALOG_ACTION,
});

export const setNewDeadline = (featureId: string, deadline: string): SetNewDeadlineAction => ({
    featureId,
    deadline,
    type: TypeKeys.SET_NEW_DEADLINE,
});

export const explanationLoaded = (featureId: string, explanationOfGrades: any): ExplanationLoadedAction => ({
    featureId,
    explanationOfGrades,
    type: TypeKeys.EXPLANATION_LOADED,
});

export const explanationIdLoaded = (featureId: string, explanationId: number): ExplanationIdLoadedAction => ({
    featureId,
    explanationId,
    type: TypeKeys.EXPLANATION_ID_LOADED,
});

export const cancelRequestOfExplanation = (featureId: string): CancelRequestOfExplanationAction => ({
    featureId,
    type: TypeKeys.CANCEL_REQUEST_OF_EXPLANATION,
});

export const editDueDateOfExplanation = (featureId: string): EditDueDateOfExplanationAction => ({
    featureId,
    type: TypeKeys.EDIT_DUE_DATE_OF_EXPLANATION,
});

export const attachFileForExplanation = (featureId: string): AttachFileForExplanationAction => ({
    featureId,
    type: TypeKeys.ATTACH_FILE_FOR_EXPLANATION,
});

export const sendExplanation = (featureId: string, sendToAllCandidates?: boolean): SendExplanationAction => ({
    featureId,
    sendToAllCandidates,
    type: TypeKeys.SEND_EXPLANATION,
});

export const loadCandidateInfo = (featureId: string, gradingPartyDocument: GradingPartyDocument): LoadCandidateInfoAction => ({
    featureId,
    gradingPartyDocument,
    type: TypeKeys.LOAD_CANDIDATE_INFO,
});

export const markAsReady = (featureId: string): MarkAsReadyAction => ({
    featureId,
    type: TypeKeys.MARK_AS_READY,
});

export const setDraft = (featureId: string): SetDraftAction => ({
    featureId,
    type: TypeKeys.SET_DRAFT,
});

export const setEditingFlag = (featureId: string, isEditing: boolean): SetEditingAction => ({
    featureId,
    isEditing,
    type: TypeKeys.SET_EDITING,
});

export const setExplanationRequestedStatus = (featureId: string, status: ExplanationOfGradesRequestStatus): SetExplanationRequestedStatusAction => ({
    featureId,
    status,
    type: TypeKeys.SET_EXPLANATION_REQUESTED_STATUS,
});

export const loadExplanation = (featureId: string, explanationId: number): LoadExplanationAction => ({
    featureId,
    explanationId,
    type: TypeKeys.LOAD_EXPLANATION,
});

export const saveExplanation = (featureId: string): SaveExplanationAction => ({
    featureId,
    type: TypeKeys.SAVE_EXPLANATION,
});

export const updateContent = (featureId: string, newContent: string): UpdateContentAction => ({
    featureId,
    newContent,
    type: TypeKeys.UPDATE_CONTENT,
});

export const lockExplanation = (featureId: string): LockExplanation => ({
    featureId,
    type: TypeKeys.LOCK_EXPLANATION,
});

export const setExplanationLocked = (featureId: string, lockInfo: any): SetExplanationLocked => ({
    featureId,
    lockInfo,
    type: TypeKeys.SET_EXPLANATION_LOCKED,
});
